import { MXValueComponent, AXValuableComponent } from '@acorex/components/common';
import { AXLabelComponent } from '@acorex/components/label';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import * as i0 from '@angular/core';
import { forwardRef, Component, ViewEncapsulation, ChangeDetectionStrategy, ContentChildren, Input, HostListener, NgModule } from '@angular/core';
import * as i1 from '@angular/forms';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { AXDecoratorModule } from '@acorex/components/decorators';
import { CommonModule } from '@angular/common';

class AXCheckBoxComponent extends MXValueComponent {
    constructor() {
        super(...arguments);
        this.indeterminate = false;
        this._stateIndeterminate = false;
    }
    internalGetValue(value) {
        if (!this.indeterminate && value == null) {
            return false;
        }
        if (this.indeterminate && value == null) {
            return null;
        }
        return coerceBooleanProperty(value);
    }
    internalSetValue(value) {
        if (this.indeterminate && value == null) {
            this._stateIndeterminate = true;
            return null;
        }
        else if (!this.indeterminate && value == null) {
            this._stateIndeterminate = false;
            return false;
        }
        else {
            this._stateIndeterminate = false;
            return value == true ? true : false;
        }
    }
    ngOnInit() {
        super.ngOnInit();
        //
        this.registerValidation();
    }
    ngAfterViewInit() {
        this._labels?.forEach((c) => {
            //TODO: remove listener
            c.getHostElement().addEventListener('click', () => {
                if (!this.readonly && !this.disabled) {
                    this.value = !this.value;
                }
            });
        });
    }
    _handleClick(e) {
        e.stopPropagation();
        if (this.readonly || this.disabled) {
            e.preventDefault();
            return false;
        }
        return true;
    }
    _handleModelChange(value) {
        this.commitValue(value, true);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.2", ngImport: i0, type: AXCheckBoxComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.0.2", type: AXCheckBoxComponent, selector: "ax-check-box", inputs: { disabled: "disabled", tabIndex: "tabIndex", readonly: "readonly", value: "value", name: "name", id: "id", checked: "checked", indeterminate: "indeterminate" }, outputs: { onBlur: "onBlur", onFocus: "onFocus", valueChange: "valueChange", onValueChanged: "onValueChanged" }, host: { listeners: { "click": "_handleClick($event)" } }, providers: [
            { provide: AXValuableComponent, useExisting: AXCheckBoxComponent },
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(() => AXCheckBoxComponent),
                multi: true,
            },
        ], queries: [{ propertyName: "_labels", predicate: AXLabelComponent }], usesInheritance: true, ngImport: i0, template: "<div class=\"ax-checkbox-label\" [class.ax-state-readonly]=\"readonly\" [class.ax-state-disabled]=\"disabled\">\n  <div class=\"ax-checkbox-start-side\">\n    <input\n      [id]=\"id\"\n      class=\"ax-checkbox\"\n      type=\"checkbox\"\n      [indeterminate]=\"_stateIndeterminate\"\n      [ngModel]=\"value\"\n      (ngModelChange)=\"_handleModelChange($event)\"\n      [checked]=\"value\"\n      [disabled]=\"disabled\"\n      [readonly]=\"readonly\"\n      [tabindex]=\"tabIndex\"\n      (focus)=\"emitOnFocusEvent($event)\"\n      (blur)=\"emitOnBlurEvent($event)\"\n    />\n  </div>\n  <div class=\"ax-checkbox-end-side\">\n    <ng-content select=\"ax-label\"></ng-content>\n    <ng-content select=\"ax-form-hint\"></ng-content>\n    <span class=\"ax-error-container\"></span>\n  </div>\n</div>\n<ng-content select=\"ax-validation-rule\"></ng-content>\n", styles: [".ax-checkbox-label{display:flex;width:fit-content;cursor:pointer;-webkit-user-select:none;user-select:none;align-items:flex-start;font-size:.875rem;line-height:1.25rem}.ax-checkbox-label.ax-state-readonly{opacity:.75}.ax-checkbox-label.ax-state-disabled{cursor:not-allowed;opacity:.5}.ax-checkbox-label.ax-state-disabled .ax-checkbox:disabled{opacity:1}.ax-checkbox-label .ax-checkbox-start-side{display:flex;height:1.25rem;align-items:center}.ax-checkbox-label .ax-checkbox-end-side{margin-inline-start:.75rem}.ax-checkbox-label .ax-checkbox-end-side ax-label label{margin-bottom:0}.ax-checkbox-label .ax-checkbox-end-side ax-form-hint{margin-top:.25rem;cursor:text;-webkit-user-select:text;user-select:text}\n"], dependencies: [{ kind: "directive", type: i1.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.2", ngImport: i0, type: AXCheckBoxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ax-check-box', inputs: ['disabled', 'tabIndex', 'readonly', 'value', 'name', 'id', 'checked'], outputs: ['onBlur', 'onFocus', 'valueChange', 'onValueChanged'], encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, providers: [
                        { provide: AXValuableComponent, useExisting: AXCheckBoxComponent },
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef(() => AXCheckBoxComponent),
                            multi: true,
                        },
                    ], template: "<div class=\"ax-checkbox-label\" [class.ax-state-readonly]=\"readonly\" [class.ax-state-disabled]=\"disabled\">\n  <div class=\"ax-checkbox-start-side\">\n    <input\n      [id]=\"id\"\n      class=\"ax-checkbox\"\n      type=\"checkbox\"\n      [indeterminate]=\"_stateIndeterminate\"\n      [ngModel]=\"value\"\n      (ngModelChange)=\"_handleModelChange($event)\"\n      [checked]=\"value\"\n      [disabled]=\"disabled\"\n      [readonly]=\"readonly\"\n      [tabindex]=\"tabIndex\"\n      (focus)=\"emitOnFocusEvent($event)\"\n      (blur)=\"emitOnBlurEvent($event)\"\n    />\n  </div>\n  <div class=\"ax-checkbox-end-side\">\n    <ng-content select=\"ax-label\"></ng-content>\n    <ng-content select=\"ax-form-hint\"></ng-content>\n    <span class=\"ax-error-container\"></span>\n  </div>\n</div>\n<ng-content select=\"ax-validation-rule\"></ng-content>\n", styles: [".ax-checkbox-label{display:flex;width:fit-content;cursor:pointer;-webkit-user-select:none;user-select:none;align-items:flex-start;font-size:.875rem;line-height:1.25rem}.ax-checkbox-label.ax-state-readonly{opacity:.75}.ax-checkbox-label.ax-state-disabled{cursor:not-allowed;opacity:.5}.ax-checkbox-label.ax-state-disabled .ax-checkbox:disabled{opacity:1}.ax-checkbox-label .ax-checkbox-start-side{display:flex;height:1.25rem;align-items:center}.ax-checkbox-label .ax-checkbox-end-side{margin-inline-start:.75rem}.ax-checkbox-label .ax-checkbox-end-side ax-label label{margin-bottom:0}.ax-checkbox-label .ax-checkbox-end-side ax-form-hint{margin-top:.25rem;cursor:text;-webkit-user-select:text;user-select:text}\n"] }]
        }], propDecorators: { _labels: [{
                type: ContentChildren,
                args: [AXLabelComponent]
            }], indeterminate: [{
                type: Input
            }], _handleClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

class AXCheckBoxModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.2", ngImport: i0, type: AXCheckBoxModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.0.2", ngImport: i0, type: AXCheckBoxModule, declarations: [AXCheckBoxComponent], imports: [CommonModule, FormsModule, AXDecoratorModule], exports: [AXCheckBoxComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.0.2", ngImport: i0, type: AXCheckBoxModule, imports: [CommonModule, FormsModule, AXDecoratorModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.2", ngImport: i0, type: AXCheckBoxModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AXCheckBoxComponent],
                    imports: [CommonModule, FormsModule, AXDecoratorModule],
                    exports: [AXCheckBoxComponent],
                    providers: [],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { AXCheckBoxComponent, AXCheckBoxModule };
